export const widgets = {
  zohoCrm: {
    settings: {
        welcomeToBotPenguin: 'Mirë se vini në BotPenguin!',
        login: 'Hyrje',
        youAreAllSet: 'Ju jeni gati! Mund të përdorni kutinë e WhatsApp nga faqja e detajeve të udhëheqësit.',
        placeholders: {
            enterEmail: 'Vendosni email',
            enterPassword: 'Vendosni fjalëkalimin'
        }
    }
}
};
